<div
    (mouseenter)="expand = true" 
    (mouseleave)="expand = false" 
    [ngClass]="{'animated-in': expand, 'animated-out': !expand}"
    class="trustpilot-container">
    <div class="data-container">
        <div class="rate-icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                <style type="text/css">
                    .st-trustpilot{fill:#333333;}
                </style>
                <path class="st-trustpilot" d="M17.9,0H2.1C1,0,0,1,0,2.1v15.7C0,19,1,20,2.1,20h15.7c1.2,0,2.1-1,2.1-2.1V2.1C20,1,19,0,17.9,0z M14.5,16.9L10,13.6l-4.5,3.3l1.7-5.3L2.8,8.4h5.5L10,3.1l1.7,5.3h5.5l-4.5,3.3L14.5,16.9z"/>
            </svg>
            <span class="rate">4.9</span>
        </div>
        <span class="reviews-count" [ngClass]="{'shown': expand, 'hidden': !expand}"> {{ 'TRUSTPILOT_REVIEWS_ON' | translate }} <span (click)="redirect('TRUSTPILOT_SMASH_PROFILE_LINK')">{{ 'TRUSTPILOT_SMASH_PROFILE' | translate }}</span> {{ 'GOOGLE_REVIEWS_AND' | translate}} <span (click)="redirect('GOOGLE_SMASH_PROFILE_LINK')">{{ 'GOOGLE_SMASH_PROFILE' | translate }}</span> {{ 'TRUSTPILOT_GOOGLE_REVIEWS_COUNT' | translate }}</span>
    </div>
</div>